import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=64b5398d&scoped=true"
import script from "./multi-select.vue?vue&type=script&lang=js"
export * from "./multi-select.vue?vue&type=script&lang=js"
import style0 from "./multi-select.vue?vue&type=style&index=0&id=64b5398d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5398d",
  null
  
)

export default component.exports